import * as React from "react";
import { useScrollbarSize } from "@mihkeleidast/react-scrollbar-size";
import { CloseButton } from "../close-button/close-button.mjs";
import { Container } from "../container/container.mjs";
import { Icon } from "../icon/icon/icon.mjs";
const iconMap = {
  info: "#info-round-filled",
  error: "#alert-filled",
  success: "#check-round-filled",
  attention: "#alert-round-filled",
  employee: "#support"
};
const Notice = (props) => {
  const element = React.createRef();
  const { width } = useScrollbarSize();
  const {
    children,
    id,
    onCloseClick,
    isCloseButtonHidden,
    type = "info",
    size,
    align,
    direction,
    className,
    closeButtonLabel,
    attributes,
    fullWidth,
    ...rest
  } = props;
  const BEM = () => {
    const classArray = ["notice"];
    if (type) {
      classArray.push("notice--" + type);
    }
    if (size) {
      classArray.push("notice--" + size);
    }
    if (align) {
      classArray.push("notice--" + align);
    }
    if (direction) {
      classArray.push("notice--" + direction);
    }
    if (onCloseClick) {
      classArray.push("notice--with-close");
    }
    if (fullWidth) {
      classArray.push("notice--full-width");
      if (fullWidth === "container") {
        classArray.push("notice--full-width-container");
      }
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const buttonProps = isCloseButtonHidden ? {
    "aria-hidden": true,
    tabIndex: -1
  } : {};
  const getCloseButtonLabel = closeButtonLabel ? { label: closeButtonLabel } : {};
  const Wrapper = fullWidth ? Container : "div";
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: BEM(),
      id,
      ref: element,
      style: {
        "--notice-scrollbar-width": "".concat(width, "px")
      },
      ...attributes,
      ...rest
    },
    /* @__PURE__ */ React.createElement(Wrapper, { className: "notice__content-wrapper" }, /* @__PURE__ */ React.createElement("div", { className: "notice__icon-cell" }, /* @__PURE__ */ React.createElement(Icon, { modifiers: iconMap[type], size: "xs", className: "notice__icon" })), /* @__PURE__ */ React.createElement("div", { className: "notice__content" }, /* @__PURE__ */ React.createElement("div", { className: "notice__inner-wrapper" }, /* @__PURE__ */ React.createElement("div", { className: "notice__inner" }, children)), onCloseClick && /* @__PURE__ */ React.createElement(CloseButton, { className: "notice__close", onClick: onCloseClick, attributes: buttonProps, ...getCloseButtonLabel })))
  );
};
export {
  Notice
};
